import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

const styles = {
  icon: {
    padding: '0px 0px'
  }
};

const enhance = compose(pure);

const button = enhance(({ classes, content, onClickAction }) => {
  return (
    <IconButton
      edge="start"
      size="small"
      onClick={() => onClickAction(content)}
    >
      <MoreHorizIcon className={classes.icon} />
    </IconButton>
  );
});

export default withStyles(styles)(button);
